import 'css-chunksrc/client/scenes/resourceEdition/calendar/styles.scss';export default {
  "calendar": "_calendar_1cse0_1",
  "column": "_column_1cse0_7",
  "case": "_case_1cse0_15",
  "formData": "_formData_1cse0_24",
  "input": "_input_1cse0_30",
  "title": "_title_1cse0_38"
};